module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app bg-gray",
    attrs: {
      "id": "gwi-voucherRegister"
    }
  }, [_c('div', {
    staticClass: "scroll"
  }, _vm._l((_vm.localIds), function(item, index) {
    return _c('section', {
      staticClass: "photo-section text-center",
      attrs: {
        "onclick": "chooseLocalImage(index)"
      }
    }, [_c('img', {
      staticClass: "photo-img",
      attrs: {
        "src": require("../../../static/img/abctest.jpg")
      }
    })])
  }), 0), _vm._v(" "), _c('section', {
    staticClass: "voucher-register-footer box"
  }, [_c('button', {
    staticClass: "btn-ok",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitImage
    }
  }, [_vm._v("上传照片")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0edf8d38","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/voucher/VoucherRegisterPhoto.vue
// module id = 784
// module chunks = 0